<template>
  <van-swipe
    :autoplay="5000"
    :class="[
      _.banner,
      theme.position === 'left'
        ? _.indicatorLeft
        : theme.position === 'right'
        ? _.indicatorRight
        : undefind,
    ]"
  >
    <van-swipe-item
      v-for="(item, index) in data"
      :key="index"
      v-track="{
        name: '轮播',
        id: 'DianJiZiDingYiYeZiYuan',
        resource: item,
        index: index,
        extra: getTrackExtra(item, index),
      }"
      :class="_.item"
      @click="$dmbcResourceClick(item)"
    >
      <van-image :class="_.image" :src="item.icon" />
    </van-swipe-item>
  </van-swipe>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({})
</script>

<style lang="scss" module="_">
  .banner {
    width: 100%;
    height: 100px;
    border-radius: var(--border-radius);
    overflow: hidden;

    .item {
      width: 100%;
      height: 100%;

      .image {
        width: 100%;
        height: 100%;

        img {
          border-radius: var(--border-radius);
          object-fit: cover;
        }
      }
    }

    :global {
      .van-swipe__indicators {
        bottom: 6px;
      }

      .van-swipe__indicator {
        width: 4px;
        height: 4px;
        background: rgba(0, 0, 0, 0.49);
        border-radius: 9px;
      }

      .van-swipe__indicator:not(:last-child) {
        margin-right: 3px;
      }

      .van-swipe__indicator--active {
        background: #ff111c;
      }
    }

    &.indicatorLeft {
      :global {
        .van-swipe__indicators {
          left: 12px;
          transform: translateX(0);
        }
      }
    }

    &.indicatorRight {
      :global {
        .van-swipe__indicators {
          left: auto;
          right: 12px;
          transform: translateX(0);
        }
      }
    }
  }
</style>
